<template>
	<div>
		<!-- 导航条 -->
		<BaseNav></BaseNav>
		<a-spin :spinning="loading">
			<div class="content">
				<div class="head-bg" :style="`background: url(${headBg});backgroundSize:cover;`"></div>
			</div>

			<div class="container">
				<div class="content-1">
					<div class="left">
						<div class="item">
							<div class="top">
								<img src="@/assets/alliance/gaoxiao.png" class="icon" alt="" />
								<div class="title">高效</div>
							</div>
							<div class="bottom">
								<span>更直接的对接上市交易所</span>
							</div>
							<div class="right-squire">
								<div class="right-squire">
									<div class="child-1"></div>
									<div class="child-2"></div>
								</div>
							</div>
						</div>
						<div class="item">
							<div class="top">
								<img src="@/assets/alliance/zhuanye.png" class="icon" alt="" />
								<div class="title">专业</div>
							</div>
							<div class="bottom">
								<span>国内知名头部专业服务机构</span>
							</div>
							<div class="right-squire">
								<div class="right-squire">
									<div class="child-1"></div>
									<div class="child-2"></div>
								</div>
							</div>
						</div>
						<div class="item">
							<div class="top">
								<img src="@/assets/alliance/gongyi.png" class="icon" alt="" />
								<div class="title">公益</div>
							</div>
							<div class="bottom">
								<span>贯彻落实省委、省政府部署</span>
							</div>
							<div class="right-squire">
								<div class="child-1"></div>
								<div class="child-2"></div>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="desc-1">
							河北省企业上市服务联盟是为了更好落实省委、省政府决策部署，高效精准推动企业上市工作，由省地方金融监管局指导河北股权交易所和证券交易所驻河北基地发起，吸引国内知名头部券商、创投公司、会计师事务所、律师事务所等专业服务机构参与，作为推动全省企业上市培育的公益性、专业化服务机构。联盟秘书处设在证券交易所驻河北基地，负责联盟日常工作。
						</div>
						<div class="desc-2">
							在省地方金融监管局指导下，联盟立足公益平台的职能定位，旨在帮助各市深入挖掘上市培育企业，利用自身专业优势为拟上市企业开展政策宣讲、专项培训和投融资对接，为企业培育、股改、上市等提供专业化指导，使企业获得专业规范的上市专项服务防止企业上市走弯路。省地方金融监管局鼓励各市县积极对接联盟秘书处，依托河北省企业上市服务联盟深度发掘辖内优质拟上市企业，帮助地方金融工作部门培育上市企业，加快推进企业上市进程!
						</div>
					</div>
				</div>
			</div>

			<div class="bg-gray">
				<div class="container">
					<!-- 秘书处 -->
					<div class="organizer">
						<div class="action-title">
							<div class="en-title">ORGANIZER</div>
							<div class="title">
								<div class="line-1"></div>
								<div class="text">秘书处</div>
								<div class="line-2"></div>
							</div>
						</div>
						<div class="contents">
							<div class="left">
								<img class="logo" src="@/assets/logo_xa.png" alt="">
							</div>
							<div class="right">
								<div>
									雄安股权交易所先后运营对接沪深北证券交易所河北服务基地、国家中小企业公共服务示范平台、全省唯一一家推动企业股改上市的河北省股改上市服务平台、全省金融资产交易服务中心和河北省中小企业孵化服务中心;发起设立了全国首家省级创新型上市服务机构--河北省企业上市服务联盟;高质量建设“专精特新"专板，助力专精特新NG
									ANE企业通过资本市场实现跨越式发展</div>
								<div class="margin-top-5">https://www.hebotc.com/</div>
							</div>
						</div>
					</div>

					<!-- 联盟成员 -->
					<div class="alliance">
						<div class="action-title">
							<div class="en-title">ALLIANCE MEMBERS</div>
							<div class="title">
								<div class="line-1"></div>
								<div class="text">联盟成员</div>
								<div class="line-2"></div>
							</div>
						</div>
						<div class="contents">
							<div class="item" v-for="(item,index) in memberList" :key="index">
								<a class="item-link" :href="item.linkUrl" target="_blank"><img :src="imagePath + item.memberLogo" class="logo" alt=""></a>
							</div>
						</div>
					</div>

					<!-- 上市服务 -->
					<div class="listing">
						<div class="action-title">
							<div class="en-title">LISTING SERVICES</div>
							<div class="title">
								<div class="line-1"></div>
								<div class="text">上市服务</div>
								<div class="line-2"></div>
							</div>
						</div>
						<div class="contents">
							<div class="top-box">
								<div class="item" v-for="(item,index) in serviceList" :key="index" v-if="index < 2">
									<div class="top">
										<div class="left-icon">
											<img :src="imagePath + item.logo" class="icon" alt="">
										</div>
										<div class="title">{{item.name}}</div>
									</div>
									<div class="desc">{{item.content}}</div>
								</div>
								
							</div>
							<div class="bottom-box">
								<div class="item" v-for="(item,index) in serviceList" :key="index" v-if="index >= 2">
									<div class="top">
										<div class="left-icon">
											<img :src="imagePath + item.logo" class="icon" alt="">
										</div>
										<div class="title">{{item.name}}</div>
									</div>
									<div class="desc">{{item.content}}</div>
								</div>
								
							</div>
						</div>
					</div>

					<!-- 新闻报道 -->
					<div class="news">
						<div class="action-title">
							<div class="en-title">NEWS REPORTS</div>
							<div class="title">
								<div class="line-1"></div>
								<div class="text">新闻报道</div>
								<div class="line-2"></div>
							</div>
						</div>
						<div class="contents">
							<router-link :to="{path:'/alliance/news-detail',query:{newsId:item.id}}" v-for="(item,index) in newsList" :key="index">
								<div class="item">
									<img :src="imagePath + item.newsImage" class="thumb" alt="" />
									<div class="title">{{item.newsTitle}}</div>
									<div class="bottom">
										<div class="date">{{item.newTime}}</div>
										<div class="dot">·</div>
										<div class="address">{{item.organizer}}</div>
									</div>
								</div>
							</router-link>
						</div>	
						<div class="more-box">
							<div class="more">查看更多</div>
						</div>
					</div>
				</div>
			</div>


			<div class="container">
				<!-- 资料下载 -->
				<div class="download">
					<div class="action-title">
						<div class="en-title">DATA DOWNLOAD</div>
						<div class="title">
							<div class="line-1"></div>
							<div class="text">资料下载</div>
							<div class="line-2"></div>
						</div>
					</div>
					<div class="contents">
						<div class="item" v-for="(item,index) in downloadList" :key="index" @click="showDownload(index)">
							<div class="title-box">
								<div class="title">{{item.name}}</div>
								<img src="@/assets/alliance/xiazai.png" class="icon" alt="" />
							</div>
							<div class="right-squire">
								<div class="right-squire">
									<div class="child-1"></div>
									<div class="child-2"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<!-- 联系我们 -->
				<div class="contact">
					<div class="contanct-title">联系我们</div>
					<div class="item">
						<div class="title">市场合作</div>
						<div class="line"></div>
						<div class="name">肖经理</div>
						<div class="phone">18877745585</div>
						<div class="email">xjl@hebotc.com</div>
					</div>
					<div class="item">
						<div class="title">商务合作</div>
						<div class="line"></div>
						<div class="name">肖经理</div>
						<div class="phone">18877745585</div>
						<div class="email">xjl@hebotc.com</div>
					</div>
					<div class="item">
						<div class="title">上市咨询</div>
						<div class="line"></div>
						<div class="name">肖经理</div>
						<div class="phone">18877745585</div>
						<div class="email">xjl@hebotc.com</div>
					</div>
				</div>
			</div>
		</a-spin>

		<a-modal width="800px" v-model="downloadModal" title="资料下载" cancelText="取消" okText="确定" @ok="handleOk">
		    <div class="file-list">
				<div class="item" v-for="(item,index) in currentDownload.dataList" :key="index">
					<div class="name">{{item.enclosureName}}</div>
					<a-button type="primary" icon="download" @click="downloadFile(item)">下载文件</a-button>
				</div>
			</div>
		</a-modal>

		<!-- 底部 -->
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	export default {
		components: {
			BaseNav,
			BaseFooter
		},
		data() {
			return {
				loading: true,
				headBg: "",
				imagePath:this.$api.baseUrl + this.$api.imgPath,
				memberList:[], //联盟成员
				serviceList:[], //上市服务列表
				downloadList:[], //下载列表
				currentDownload:[],
				newsList:[], //新闻列表
				downloadModal:false,
			}
		},
		created() {
			document.title = "雄安股权交易所-上市服务联盟";
			this.menuPosition = "1805814848093712385";
			this.getHeadBanner()
			this.unionMemberPageList()
			this.queryUnionServerList()
			this.unionDataList()
			this.unionNewsList()
		},
		methods: {
			//获取新闻列表
			unionNewsList(){
				this.$request({
					url:this.$api.alliance.unionNewsList,
					data:{newsTitle:"",newsType:"1797890605002596353",pageNo:1,pageSize:8}
				}).then((res)=>{
					this.newsList = res.data.result.records;
				})
			},
			//下载
			downloadFile(item){
				let file = this.$api.downloadPath + item.enclosureUrl;
				let link = document.createElement("a")
				link.href = file;
				link.setAttribute('download',item.enclosureName)
				link.click()
			},
			// 关闭弹窗
			handleOk(){
				this.downloadModal = false;
			},
			//显示文件弹窗
			showDownload(index){
				this.currentDownload = this.downloadList[index];
				if(this.currentDownload.dataList==""){
					 this.$message.warning("暂无资料！");
				}else{
					this.downloadModal = true;
				}
			},
			//资料下载列表
			unionDataList(){
				this.$request({
					url:this.$api.alliance.unionDataList
				}).then((res)=>{
					this.downloadList = res.data.result;
				})
			},
			// 上市服务列表
			queryUnionServerList(){
				this.$request({
					url:this.$api.alliance.queryUnionServerList,
				}).then((res)=>{
					this.serviceList = res.data.result;
				})
			},
			//获取联盟成员
			unionMemberPageList(){
				this.$request({
					url:this.$api.alliance.unionMemberPageList,
					data:{pageNo:1,pageSize:10}
				}).then((res)=>{
					this.memberList = res.data.result.records;
				})
			},
			// 获取轮播图
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
					this.loading = false;
				})
			},
		}
	}
</script>
<style>

</style>
<style scoped>
	.head-bg {
		width: 100%;
		height: 496px;
	}

	.content-1 {
		margin-top: 80px;
		display: flex;
		justify-content: space-between;
		padding-bottom: 80px;
	}

	.content-1 .left {}

	.content-1 .left .item {
		width: 360px;
		height: 113px;
		background-color: #fff;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
		margin-bottom: 30px;
		padding: 20px 40px;
		position: relative;
	}

	.content-1 .left .item .top {
		display: flex;
		align-items: center;
	}

	.content-1 .left .item .top .icon {}

	.content-1 .left .item .top .title {
		font-size: 25px;
		margin-left: 20px;
	}

	.content-1 .left .item .bottom {
		margin-top: 10px;
		font-size: 16px;
	}

	.content-1 .left .item .bottom span {
		margin-left: 56px;
	}

	.content-1 .right {
		width: 783px;
		font-size: 20px;
	}

	.content-1 .right .desc-1 {
		text-indent: 2em;
		line-height: 1.8em;
	}

	.content-1 .right .desc-2 {
		text-indent: 2em;
		line-height: 1.8em;
	}

	.content-1 .right-squire {
		width: 20px;
		height: 20px;
		background-color: #e9f0fe;
		position: absolute;
		right: 0;
		bottom: 0;
		z-index: 1;
	}

	.content-1 .right-squire .child-1 {
		width: 15px;
		height: 15px;
		background-color: #cbdbfd;
		position: absolute;
		right: -5px;
		bottom: -5px;
		z-index: 2;
	}

	.content-1 .right-squire .child-2 {
		width: 10px;
		height: 10px;
		background-color: #1967fa;
		position: absolute;
		right: 0;
		bottom: 0;
		z-index: 3;
	}

	.bg-gray {
		background-color: #f8f9fe;
		padding-top: 80px;
	}

	.action-title {
		text-align: center;
	}

	.action-title .title {
		margin-top: -28px;
		color: #1967fa;
		font-size: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.action-title .title .line-1 {
		width: 40px;
		height: 6px;
		background: linear-gradient(90deg, rgba(117, 164, 252, 1) 0%, rgba(245, 247, 254, 1) 100%);
		margin-right: 20px;
		margin-top: 5px;
	}

	.action-title .title .line-2 {
		width: 40px;
		height: 6px;
		background: linear-gradient(90deg, rgba(245, 247, 254, 1) 0%, rgba(117, 164, 252, 1) 100%);
		margin-left: 20px;
		margin-top: 5px;
	}

	.action-title .en-title {
		letter-spacing: 2px;
		font-size: 26px;
		background-image: linear-gradient(180deg, rgba(114, 241, 125, 1) 0%, rgba(233, 248, 239, 1) 100%);
		background-color: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		font-weight: bold;
	}

	.organizer {}

	.organizer .contents {
		margin-top: 50px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #fff;
		padding: 40px 50px;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);

	}

	.organizer .contents .right {
		margin-left: 30px;
		font-size: 15px;
		line-height: 1.6em;
		color: #666666;
	}

	.alliance {
		margin-top: 80px;
	}

	.alliance .contents {
		margin-top: 50px;
		display: flex;
		flex-wrap: wrap;
		gap: 50px;
	}

	.alliance .contents .item {
		width: 200px;
		height: 100px;
		background-color: #ffffff;
		border: 1px solid #e7efff;
		
	}
	
	.alliance .contents .item .logo{
		width: 140px;
	}
	
	.alliance .contents .item .item-link{
		display: block;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.listing {
		clear: both;
		margin-top: 80px;
	}

	.listing .contents {
		margin-top: 50px;
	}
	
	.listing .contents .top-box{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.listing .contents .top-box .item{
		width: 580px;
		background-color: #fff;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
	}
	
	.listing .contents .top-box .item .top{
		display: flex;
		align-items: center;
		background-color: #f3f7ff;
	}
	
	.listing .contents .top-box .item .top .left-icon{
		width: 80px;
		height: 80px;
		background-color: #1967fa;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.listing .contents .top-box .item .top .left-icon .icon{
		width: 40px;
	}
	
	.listing .contents .top-box .item .top .title{
		margin-left: 30px;
		font-size: 24px;
		font-weight: bold;
	}
	
	.listing .contents .top-box .item  .desc{
		font-size: 18px;
		color: #666666;
		padding:30px;
	}
	
	.listing .contents .bottom-box{
		margin-top: 40px;
		display: flex;
		gap:30px;
	}
	
	.listing .contents .bottom-box .item{
		width: 380px;
		background-color: #fff;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
	}
	
	.listing .contents .bottom-box .item .top{
		display: flex;
		align-items: center;
		background-color: #f3f7ff;
	}
	
	.listing .contents .bottom-box .item .top .left-icon{
		width: 80px;
		height: 80px;
		background-color: #1967fa;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.listing .contents .bottom-box .item .top .left-icon .icon{
		width: 40px;
	}
	
	.listing .contents .bottom-box .item .top .title{
		margin-left: 30px;
		font-size: 24px;
		font-weight: bold;
	}
	
	.listing .contents .bottom-box .item  .desc{
		font-size: 18px;
		color: #666666;
		padding:30px;
	}
	
	.news {
		margin-top: 80px;
		padding-bottom: 80px;
	}

	.news .contents {
		margin-top: 50px;
		display: flex;
		flex-wrap: wrap;
		gap:12px;
	}
	
	.news .contents .item{
		width: 290px;
		margin-bottom: 30px;
		background-color: #fff;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
	}

	.news .contents .item .thumb{
		width: 290px;
		height: 165px;
		object-fit: cover;
	}
	
	.news .contents .title{
		padding:20px;
		font-size: 16px;
		color: #333;
	}
	
	.news .contents .item .bottom{
		display: flex;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
		color: #999;
		font-size: 12px;
	}
	
	.news .contents .item .bottom .dot{
		margin-left: 3px;
		margin-right: 3px;
		
	}
	
	.news .more-box{
		margin-top: 30px;
		display: flex;
		justify-content: center;
	}
	
	.news .more-box .more{
		width: 190px;
		height: 48px;
		color: #1967fa;
		border: 2px solid #1967fa;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		border-radius:6px;
		cursor: pointer;
	}

	.download {
		padding-top: 80px;
		padding-bottom: 80px;
	}
	
	.download .contents{
		display: flex;
		flex-wrap: wrap;
		gap: 30px;
		margin-top: 50px;
	}
	
	.download .contents .item{
		width: 380px;
		height: 126px;
		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
		position: relative;
		padding:30px;
		cursor:pointer;
	}
	
	.download .contents .item .title-box{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.download .contents .item .title{
		font-size: 18px;
		width:250px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	
	.download .contents .item .icon{
		width: 40px;
	}
	
	.download .contents .item .right-squire {
		width: 20px;
		height: 20px;
		background-color: #e9f0fe;
		position: absolute;
		right: 0;
		bottom: 0;
		z-index: 1;
	}
	
	.download .contents .item .right-squire .child-1 {
		width: 15px;
		height: 15px;
		background-color: #cbdbfd;
		position: absolute;
		right: -5px;
		bottom: -5px;
		z-index: 2;
	}
	
	.download .contents .item .right-squire .child-2 {
		width: 10px;
		height: 10px;
		background-color: #1967fa;
		position: absolute;
		right: 0;
		bottom: 0;
		z-index: 3;
	}
	
	.contact{
		margin-top:30px;
		display: flex;
		justify-content: space-between;
		padding-bottom: 80px;
	}
	
	.contact .contanct-title{
		font-size: 40px;
		color: #1967fa;
	}
	
	.contact .item{
		
	}
	
	.contact .item .title{
		font-size: 22px;
		font-weight: bold;
	}
	
	.contact .item .line{
		width:20px;
		height: 2px;
		background-color: #1967fa;
		margin-top: 20px;
	}
	
	.contact .item .name{
		color: #666;
		font-size: 18px;
		margin-top:20px;
	}
	
	.contact .item .phone{
		color: #666;
		font-size: 18px;
		margin-top:20px;
	}
	
	.contact .item .email{
		color: #666;
		font-size: 18px;
		margin-top:20px;
	}
	
	.file-list{
		
	}
	
	.file-list .item{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding:15px 0px;
		border-bottom: 1px #d9d9d9 dashed;
	}
</style>


// WEBPACK FOOTER //
// src/pages/alliance/index.vue